import styled, { css } from 'styled-components';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 28px;

  @media (max-width: 768px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const Title = styled.h1`
  color: #252b37;
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 8px;
`;

export const Subtitle = styled.p`
  color: #6b5555;
  font-size: 14px;
  margin: 0;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 22px 28px;
  border-radius: 6px;
  background: #ed0039;
  box-shadow: 0 4px 10px rgb(0 0 0 / 10%);
  margin-bottom: 28px;

  button {
    border-color: #fff;
    color: #fff;
  }

  @media (max-width: 768px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: min(100%, 520px);
  color: #fff;
  font-size: 22px;
  border-bottom: 1px solid rgb(255 255 255 / 80%);
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 8px 0 10px;
  border: 0;
  outline: none;
  background: transparent;
  color: #fff;
  font-size: 14px;
  font-weight: 600;

  &::placeholder {
    color: rgb(255 255 255 / 90%);
  }
`;

export const TableCard = styled.div`
  overflow: hidden;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 4px 12px rgb(0 0 0 / 8%);
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 24px 28px;
    text-align: left;
  }

  th {
    color: #4b4b4b;
    font-size: 14px;
    font-weight: 700;
  }

  td {
    color: #5c5c5c;
    font-size: 14px;
    border-top: 16px solid #f7f8fb;
  }

  @media (max-width: 900px) {
    thead {
      display: none;
    }

    tr,
    td {
      display: block;
    }

    tr {
      padding: 12px 20px;
      border-top: 16px solid #f7f8fb;
    }

    td {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
      padding: 8px 0;
      border: 0;
      text-align: right;

      &::before {
        content: attr(data-label);
        color: #4b4b4b;
        font-weight: 700;
        text-align: left;
      }
    }
  }
`;

export const Status = styled.span<{
  tone: 'processing' | 'available' | 'expired' | 'error';
}>`
  font-weight: 500;

  ${({ tone }) =>
    tone === 'processing' &&
    css`
      color: #f28c28;
    `}

  ${({ tone }) =>
    tone === 'available' &&
    css`
      color: #309846;
    `}

  ${({ tone }) =>
    (tone === 'expired' || tone === 'error') &&
    css`
      color: #ed1745;
    `}
`;

export const DownloadButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 36px;
  border: 0;
  border-radius: 5px;
  background: #ed0039;
  color: #fff;
  cursor: pointer;
  font-size: 18px;

  &:disabled {
    cursor: wait;
    opacity: 0.6;
  }
`;

export const ReprocessButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 36px;
  padding: 8px 14px;
  border: 0;
  border-radius: 5px;
  background: #ed0039;
  color: #fff;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    cursor: wait;
    opacity: 0.7;
  }

  svg.is-loading {
    animation: reprocess-spin 1s linear infinite;
  }

  @keyframes reprocess-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const WaitText = styled.span`
  color: #666;
`;

export const EmptyState = styled.div`
  padding: 40px 24px;
  color: #666;
  text-align: center;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  margin-top: 28px;

  @media (max-width: 900px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const Warning = styled.div`
  max-width: 900px;
  padding: 16px 22px;
  border-radius: 4px;
  background: #f4e2e2;
  color: #765b5b;
  font-size: 13px;
  line-height: 1.5;

  strong:first-child {
    color: #d71920;
  }
`;
